export default __webpack_public_path__ + "static/media/xCyber-contract.a3c76ebf.png";